import { EyeIcon } from "../../../components/Icons";
import { Link } from "react-router-dom";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { format, parse } from "date-fns";

const { handlerModal } = useGeneralAppStore.getState();

export const tableData = (data, setRow, width) => {
  // console.log("data", data);
  const columns = [
    {
      field: "numero_acta",
      headerName: "Acta",
      width: 60,
      maxWidth: width >= 560 ? 80 : 60,
      flex: 1,
      renderCell: (params) => {
        return <div style={{ fontSize: width < 576 && "10px" }}>{params.row.numero_acta}</div>;
      },
    },
    {
      field: "codigo_postal",
      headerName: "C.P",
      width: 60,
      maxWidth: width >= 560 ? 80 : 60,
      flex: 1,
      renderCell: (params) => {
        return <div style={{ fontSize: width < 576 && "10px" }}>{params.row.codigo_postal}</div>;
      },
    },
    {
      field: "localidad",
      headerName: "Localidad",
      width: 80,
      maxWidth: 120,
      flex: 1,
      renderCell: (params) => {
        return <div style={{ fontSize: width < 576 && "10px" }}>{params.row.localidad}</div>;
      },
    },
    ...(width >= 576
      ? [{ field: "documento_titular", headerName: "DNI", flex: 1, maxWidth: 100, minWidth: 60 }]
      : []),
    // { field: "modelo_vehiculo", headerName: "Modelo", hide: true, minWidth: 125, flex: 1.5 },
    { field: "id", headerName: "ID" },
    ...(width >= 576
      ? [
          {
            field: "plate",
            headerName: "Patente",
            minWidth: 60,
            maxWidth: 80,
            flex: 1,
            renderCell: (params) => {
              return <div style={{ fontSize: width < 576 && "10px" }}>{params.row.plate}</div>;
            },
          },
        ]
      : []),
    {
      field: "direccion_titular",
      headerName: "Dirección Titular",
      minWidth: 60,
      maxWidth: 600,
      flex: 1.5,

      renderCell: (params) => {
        return (
          <div style={{ fontSize: width < 576 && "10px" }}>
            {params.row.direccion_titular.split("-")[0]}
          </div>
        );
      },
    },
    ...(width >= 576
      ? [
          {
            field: "fecha_asignado",
            headerName: "Fecha asignado",
            minWidth: 30,
            maxWidth: 200,
            flex: 1,
            renderCell: (params) => {
              return (
                <div>
                  {format(
                    parse(params.row.fecha_asignado, "yyyy-MM-dd HH:mm:ss", new Date()),
                    "dd/MM/yy HH:mm"
                  )}
                </div>
              );
            },
          },
        ]
      : []),

    // {
    //   field: "actions",
    //   headerName: "Acciones",
    //   width: 80,

    //   renderCell: (params) => {
    //     return (
    //       <>
    //         <div className="d-flex  mx-auto">
    //           <Link
    //             onClick={() => {
    //               setRow(params.row);
    //               handlerModal({ modal: true, modalName: "modal_notificar" });
    //               // setShowModal(true);
    //             }}
    //             style={{ textDecoration: "none" }}
    //           >
    //             <EyeIcon />
    //           </Link>
    //         </div>
    //       </>
    //     );
    //   },
    // },
  ];

  const rows = data?.map((d, index) => {
    // console.log('data', d);
    return {
      documento_titular: d?.documento_titular,
      fecha_asignado: d?.notificadores[0].fecha_asignado,
      numero_acta: d?.numero_acta,
      latitud: d?.latitud,
      longitud: d?.longitud,
      codigo_postal: d?.codigo_postal,
      localidad: d?.localidad,
      modelo_vehiculo: d?.modelo_vehiculo,
      marca_vehiculo: d?.marca_vehiculo,
      id: d?.id,
      created_at: d?.created_at,
      plate: d?.plate,
      tipo: d?.tipo,
      direccion_titular: `${d?.direccion_titular} ${d?.localidad}`,
      // estado: d?.estado?.descripcion,
      fecha_notificacion: d?.fecha_notificacion,
      observacion: d?.observacion_notificador,
      event: d?.event,
      estado_id: d?.estado_id,
      motivo_no_notificado: d?.motivo_no_notificado,
    };
  });

  const filter = (d, value) => {
    value = value?.toLowerCase();

    return (
      String(d?.id)?.toString().toLowerCase().includes(value) ||
      String(d?.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
